<template>
	<aside class="sidebar fixed bottom-0 z-10 bg-white" :style="computedStyle" :class="{'border-r': border}">
		<div class="flex flex-column h-full">
			<slot name="header"/>
			<box class="flex-grow-1">
				<slot/>
			</box>
			<slot name="footer"/>
		</div>
	</aside>
</template>

<script>
import {formatDimension} from "@spoferan/spoferan-ts-core";

    export default {
        name: "Sidebar",

        props: {

            width: {
                type: [Number, String],
                default: 300
            },

            // Whether a border shall be shown around the sidebar
            border: {
                type: Boolean,
                default: false
            },

            // The spacing from the top -> required to be placed below a fixed header
            top: {
                type: [Number, String],
                default: 56
            }
        },

        computed: {
            computedStyle() {
                return {
                    width: formatDimension(this.width),
                    top: formatDimension(this.top),
                };
            }
        }
    }
</script>
<style>
/*********************
  Typography
**********************/
/*********************
  Inputs
**********************/
/*********************
  Shadows
**********************/
/*********************
  Layout
**********************/
/*********************
  Card
**********************/
/*********************
  Opacity
**********************/
@media (min-width: 768px) and (max-width: 1023px) {
  .sidebar {
    box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.1);
  }
}
@media (max-width: 639px) {
  .sidebar {
    width: 100vw !important;
  }
}
</style>